import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  marginTop: theme.spacing(6),
}));

export const TripDataContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridGap: theme.spacing(8),
  gridTemplateColumns: 'repeat(3, 1fr)',

  [theme.breakpoints.down('iPadPro')]: {
    gridGap: theme.spacing(4),
  },
}));

export const TripDataColumn = styled('div')(({ theme }) => ({
  '> * + *': {
    marginTop: theme.spacing(2),
  },
}));
